<div class="upload-instructions-modal-body">
	<div class="d-flex justify-content-center">
		<div class="d-flex flex-column upload-instructions-modal-container">
			<!-- Step 1: Template Download -->
			<div class="border rounded p-4 upload-instructions-modal-section">
				<div class="d-flex flex-column w-100">
					<div class="d-flex align-items-center mb-4">
						<div
							class="number-title"
							data-e2e-documents-upload-instructions-modal-template-title>
							{{ 'documents-upload-instructions-modal.DocumentTemplateTitle' | translate }}
						</div>
					</div>
					<div class="mb-4">
						<p
							class="mb-0 upload-instructions-modal-description"
							data-e2e-documents-upload-instructions-modal-template-description>
							{{ 'documents-upload-instructions-modal.DocumentTemplateInfoText' | translate }}
						</p>
					</div>
					<div class="d-flex justify-content-end">
						<eif-custom-button
							[text]="'documents-upload-instructions-modal.DocumentTemplate'"
							(action)="downloadTemplate()">
						</eif-custom-button>
					</div>
				</div>
			</div>
			<!-- Step 2: Instructions -->
			<div class="border rounded p-4 upload-instructions-modal-section">
				<div class="d-flex flex-column w-100">
					<div class="d-flex align-items-center mb-4">
						<div class="number-title">
							{{ 'documents-upload-instructions-modal.DocumentTemplateInstructionsTitle' | translate }}
						</div>
					</div>
					<div>
						@if (showConfirmingUploadInstructions()) {
							<eif-documents-upload-confirming-instructions></eif-documents-upload-confirming-instructions>
						}
						@if (showFactoringUploadInstructions()) {
							<eif-documents-upload-factoring-instructions></eif-documents-upload-factoring-instructions>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
